import { render, staticRenderFns } from "./extCol.vue?vue&type=template&id=ab01f2a0&"
import script from "./extCol.vue?vue&type=script&lang=js&"
export * from "./extCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports